












































import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { RootStoreState } from '@/store';
import { ScrollView } from '../scroll-view';
import { State } from 'vuex-class';
import { DashBoardStoreState } from '..';
import UUIFComponents from '@/shared/uuifComponent';
import DefconProgress from '@/modules/msw-products/components/defcon-progress.vue';
import { DropdownLight } from '../../../shared/dropdown-light';
import WidgetUnit from './msw-widget-unit.vue';
const cssPrefix = 'msw_dashboard_card';

@Component({
  components: {
    ...UUIFComponents,
    ScrollView,
    DropdownLight,
    WidgetUnit,
    DefconProgress,
  },
})

export default class DashboardCardView extends SwExtendedVue{
  showTenant: boolean = false;
  cssPrefix = cssPrefix;
  @State((state: RootStoreState) => state.DashBoardStoreModule.filteredCustomers)
  customersDetails: DashBoardStoreState['filteredCustomers'];
  @State((state: RootStoreState) => state.DashBoardStoreModule.activeFilterStatus)
  activeFilterStatus: 'All'|'Starred'|'sharedToMe'|'sharedByMe';
  isLoadingPartialDataset: boolean = false;
  partialData: any[] = [];
  switchCss = this.$store.getters['DashBoardStoreModule/getSwitchCss'];

  created() {
    this.partialData = this.customersDetails.slice(0, 50);
    if (this.switchCss) {
      if (this.partialData.length === 0) {
        this.showTenant = true;
      }
    }
  }
  getCustomerList(data: any) {
    this.$emit('updateCustomerList', data);
  }

  @Watch('customersDetails')
  doesTenantExist(res: any) {
    res.length === 0 ? this.showTenant = true : this.showTenant = false;
    this.partialData = this.customersDetails.slice(0, 50);
  }
  scrollEnded() {
    this.onLoadMore(20);
  }

  private onLoadMore(minNumToLoad: number) {
    if (this.isLoadingPartialDataset) { return; }
    this.loadData(this.partialData.length, Math.max(minNumToLoad, 20));
  }

  private loadData(start: number, length: number) {
    if (length <= 0) { return Promise.resolve(0); }

    this.isLoadingPartialDataset = true;
    return new Promise<number>((resolve) => {
      setTimeout(
        () => {
          let count = 0;
          for (; count < length && (start + count) < this.customersDetails.length; count += 1) {
            this.partialData.push(this.customersDetails[start + count]);
          }
          this.isLoadingPartialDataset = false;
          resolve(count);
        },
        200,
      );
    });
  }
  get getTenentsNotFoundMsg() {
    const msg : { main:string, sub:string } = { main: '', sub: '' };
    switch (this.activeFilterStatus) {
      case 'All': msg.main = 'No Tenants Found';
        msg.sub = 'Click on create tenant button to create a new tenant';
        break;
      case 'Starred': msg.main = 'No Tenants Found Matching Your Filter Criteria';
        msg.sub = `Click on All Tenants to view all the tenants or
                   click on create tenant button to create a new tenant`;
        break;
      case 'sharedToMe': msg.main = 'No Tenants Found Matching Your Filter Criteria';
        msg.sub = `Click on All Tenants to view all the tenants or
                   click on create tenant button to create a new tenant`;
        break;
      case 'sharedByMe': msg.main = 'No Tenants Found Matching Your Filter Criteria';
        msg.sub = `Click on All Tenants to view all the tenants or
                   click on create tenant button to create a new tenant`;
        break;
    }
    return msg;
  }
}
